module.exports = __webpack_public_path__ + "img/freespin_feature.1465fbbf.png";